import { useState, useEffect, useCallback } from 'react';
import { useWebSocket } from '../../../context/WebSocketContext';
import { ThinkingStep } from '../types';

export const useDamiaThinking = (conversationId: string | null) => {
    const { socket, isConnected } = useWebSocket();
    const [thinkingSteps, setThinkingSteps] = useState<ThinkingStep[]>([]);
    const [isThinkingActive, setIsThinkingActive] = useState(false);

    useEffect(() => {
        if (!socket || !isConnected || !conversationId) return;

        const handleThinkingStep = (step: ThinkingStep) => {
            if (step.conversationId !== conversationId) return;

            setIsThinkingActive(true);

            setThinkingSteps(prev => {
                const existingIndex = prev.findIndex(s => s.stepId === step.stepId);
                if (existingIndex >= 0) {
                    const updated = [...prev];
                    updated[existingIndex] = step;
                    return updated;
                }
                return [...prev, step].sort((a, b) => a.order - b.order);
            });
        };

        socket.on('damiaThinkingStep', handleThinkingStep);

        return () => {
            socket.off('damiaThinkingStep', handleThinkingStep);
        };
    }, [socket, isConnected, conversationId]);

    const resetThinking = useCallback(() => {
        setThinkingSteps([]);
        setIsThinkingActive(false);
    }, []);

    return { thinkingSteps, isThinkingActive, resetThinking };
};
